export default __webpack_public_path__ + "static/media/favicon-32x32.3f6d7803.png";